import { Component, HostListener, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CiamService } from '../../../../_services/ciam.service';
import { ResponsiveService } from '../../../../_services/responsive.service';
import { LoginContextEnum } from '../login.component';

@Component({
  selector: 'ng-casto-customer-login-form',
  templateUrl: './login-form.component.html'
})
export class CustomerLoginFormComponent {
  @Output() switchContext = new EventEmitter<LoginContextEnum>();

  loading = false;

  protected readonly LoginContext = LoginContextEnum;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly ciamService: CiamService,
    public readonly responsive: ResponsiveService,
  ) {}

  /** Revenu par « Précédent », le navigateur restaure la page telle qu'on l'a quittée, bouton en chargement compris. */
  @HostListener('window:pageshow', ['$event'])
  onPageShow(event: PageTransitionEvent): void {
    if (event.persisted) {
      this.loading = false;
    }
  }

  onSwitchContext(loginContext: LoginContextEnum) {
    this.switchContext.emit(loginContext);
  }

  loginUser(): void {
    this.loading = true;
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/accueil';
    this.ciamService.redirectToSignIn(returnUrl);
  }

  createCard(): void {
    this.ciamService.redirectToRegister('/creation');
  }
}
